export const EFW = {
  22: {
    '3rd': 463,
    '5th': 470,
    '10th': 481,
    '50th': 525,
    '90th': 578,
    '95th': 596,
    '97th': 607,
  },
  23: {
    '3rd': 516,
    '5th': 524,
    '10th': 538,
    '50th': 592,
    '90th': 658,
    '95th': 680,
    '97th': 695,
  },
  24: {
    '3rd': 575,
    '5th': 585,
    '10th': 602,
    '50th': 669,
    '90th': 751,
    '95th': 778,
    '97th': 796,
  },
  25: {
    '3rd': 641,
    '5th': 654,
    '10th': 674,
    '50th': 756,
    '90th': 858,
    '95th': 891,
    '97th': 913,
  },
  26: {
    '3rd': 716,
    '5th': 732,
    '10th': 757,
    '50th': 856,
    '90th': 980,
    '95th': 1020,
    '97th': 1048,
  },
  27: {
    '3rd': 800,
    '5th': 818,
    '10th': 849,
    '50th': 969,
    '90th': 1119,
    '95th': 1168,
    '97th': 1202,
  },
  28: {
    '3rd': 892,
    '5th': 915,
    '10th': 951,
    '50th': 1097,
    '90th': 1276,
    '95th': 1335,
    '97th': 1375,
  },
  29: {
    '3rd': 994,
    '5th': 1021,
    '10th': 1065,
    '50th': 1239,
    '90th': 1452,
    '95th': 1521,
    '97th': 1569,
  },
  30: {
    '3rd': 1106,
    '5th': 1138,
    '10th': 1190,
    '50th': 1396,
    '90th': 1647,
    '95th': 1728,
    '97th': 1783,
  },
  31: {
    '3rd': 1227,
    '5th': 1265,
    '10th': 1326,
    '50th': 1568,
    '90th': 1860,
    '95th': 1953,
    '97th': 2016,
  },
  32: {
    '3rd': 1357,
    '5th': 1401,
    '10th': 1473,
    '50th': 1755,
    '90th': 2089,
    '95th': 2195,
    '97th': 2266,
  },
  33: {
    '3rd': 1495,
    '5th': 1547,
    '10th': 1630,
    '50th': 1954,
    '90th': 2332,
    '95th': 2450,
    '97th': 2529,
  },
  34: {
    '3rd': 1641,
    '5th': 1700,
    '10th': 1795,
    '50th': 2162,
    '90th': 2583,
    '95th': 2713,
    '97th': 2800,
  },
  35: {
    '3rd': 1792,
    '5th': 1860,
    '10th': 1967,
    '50th': 2378,
    '90th': 2838,
    '95th': 2978,
    '97th': 3071,
  },
  36: {
    '3rd': 1948,
    '5th': 2024,
    '10th': 2144,
    '50th': 2594,
    '90th': 3089,
    '95th': 3237,
    '97th': 3335,
  },
  37: {
    '3rd': 2106,
    '5th': 2190,
    '10th': 2321,
    '50th': 2806,
    '90th': 3326,
    '95th': 3480,
    '97th': 3582,
  },
  38: {
    '3rd': 2265,
    '5th': 2355,
    '10th': 2495,
    '50th': 3006,
    '90th': 3541,
    '95th': 3697,
    '97th': 3799,
  },
  39: {
    '3rd': 2422,
    '5th': 2516,
    '10th': 2663,
    '50th': 3186,
    '90th': 3722,
    '95th': 3876,
    '97th': 3976,
  },
  40: {
    '3rd': 2574,
    '5th': 2670,
    '10th': 2818,
    '50th': 3338,
    '90th': 3858,
    '95th': 4006,
    '97th': 4101,
  },
};
